// extracted by mini-css-extract-plugin
module.exports =  {"root":"p6qk8kucsisCSrZPjH7w"};